export const COIN_GECKO_V3 = "https://api.coingecko.com/api/v3";

export const DASHBOARD_API_URL = `${COIN_GECKO_V3}/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false`;

export const COMPARE_API_URL = "";

export const COIN_API_URL = "";
